import { render } from "./BaseCustomCheckbox.vue?vue&type=template&id=3049e776&scoped=true"
import script from "./BaseCustomCheckbox.vue?vue&type=script&lang=js"
export * from "./BaseCustomCheckbox.vue?vue&type=script&lang=js"

import "./BaseCustomCheckbox.vue?vue&type=style&index=0&id=3049e776&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3049e776"]])

export default __exports__